// utils/toast.js
import { toast } from 'react-toastify';

/**
 * Toast Deduplication Service
 * Prevents duplicate toast messages from appearing within a specified time window
 * Best practice: Show only unique messages to avoid notification spam
 */
const toastHistory = new Map(); // { message: lastTimestamp }
const DEDUP_TIMEOUT = 2000; // 2 seconds - prevent same message within this window

const isDuplicateToast = (message) => {
    const lastShown = toastHistory.get(message);
    const now = Date.now();

    if (lastShown && (now - lastShown) < DEDUP_TIMEOUT) {
        return true; // Duplicate within timeout window
    }

    // Update history
    toastHistory.set(message, now);
    return false;
};

/**
 * Helper to emit toast only if not a duplicate
 */
const safeToast = (toastFn, message) => {
    if (!isDuplicateToast(message)) {
        toastFn(message);
    }
};

// Success toast - with deduplication
export const showSuccessToast = (message) => {
    safeToast(toast.success, message);
};

// Error toast - with deduplication
export const showErrorToast = (message) => {
    safeToast(toast.error, message);
};

// Info toast - with deduplication
export const showInfoToast = (message) => {
    safeToast(toast.info, message);
};

// Warning toast - with deduplication
export const showWarnToast = (message) => {
    safeToast(toast.warn, message);
};

/**
 * Force show toast without deduplication
 * Use when you NEED to show the same message even if recently shown
 */
export const forceShowToast = (type, message) => {
    if (type === 'success') toast.success(message);
    else if (type === 'error') toast.error(message);
    else if (type === 'info') toast.info(message);
    else if (type === 'warn') toast.warn(message);
};
